import { BaseESDoc } from './types';

export interface Indexable<T extends BaseESDoc> {
	id: number;
	toESDoc(data?: {}): T;
}
